import React from "react";
import { QueueVideos } from "../bookui/components/QueueVideos";

export default function QueueVideosPage() {
  return (
    <div className="min-h-full w-full min-w-0 bg-gradient-to-b from-slate-50 to-white">
      <div className="mx-auto max-w-5xl px-4 py-6 sm:px-6 sm:py-8 lg:max-w-6xl lg:px-8">
        <header className="mb-6 min-w-0 sm:mb-8">
          <p className="text-xs font-semibold uppercase tracking-wider text-primary">
            Clinical settings
          </p>
          <h1 className="mt-1 text-xl font-bold tracking-tight text-slate-900 sm:text-2xl">
            Queue videos
          </h1>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-600 sm:text-[0.9375rem]">
            Upload multiple videos to play on the queue screen (right side). Videos are stored on
            AWS and served via signed URLs.
          </p>
        </header>

        <div className="flex min-w-0 flex-col gap-5 sm:gap-6 lg:gap-8" role="main">
          <QueueVideos />
        </div>
      </div>
    </div>
  );
}

